import React, { useEffect, useState } from 'react';
import kcService from '../../services/kc.service';
import { IOrder } from '../../modals/Orders.modal';

const KCOrders: React.FC = () => {
    const [orders, setOrders] = useState<IOrder[]>();

    useEffect(() => {
        setOrders([]);
        kcService.getAllOrders().then((response) => {
            return setOrders(response.data.data);
        }).catch((error) => {
            console.log('Error fetching orders:', error);
            alert(`Error fetching orders: ${error.response.data.message}`);
        });
    }, []);

    return (
        <div className="container mt-2">
            <h2 className='titleColor'>Orders</h2>
            <div className="card overflow-hidden">
                <div className="table-responsive">
                    <table className="table table-striped mb-0" style={{ fontSize: '14px' }}>
                        <thead>
                            <tr>
                                <th>Exchange</th>
                                <th>Product</th>
                                <th>Placed by</th>
                                <th>Order ID</th>
                                <th>Quantity</th>
                                <th>Avg Price</th>
                                <th>Variety</th>
                                <th>Order type</th>
                                <th>Transaction type</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders?.map(order => (
                                <tr key={order.exchange_order_id}>
                                    <td>{order.exchange}</td>
                                    <td>{order.product}</td>
                                    <td>{order.placed_by}</td>
                                    <td>{order.order_id}</td>
                                    <td>{order.quantity}</td>
                                    <td>{order.average_price}</td>
                                    <td>{order.variety}</td>
                                    <td>{order.order_type}</td>
                                    <td>{order.transaction_type}</td>
                                    <td>{order.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default KCOrders;